<template>
  <tr v-if="inventories">
    <th class="sheet-header text-truncate text-capitalize font-weight-regular" style="border-left: 2px solid white">Available</th>
    <td class="sheet-cell text-center" v-for="(inventory, index) in inventories" :key="index">
      <v-progress-circular v-if="inventory.au" size="12" width="2" indeterminate/>
      <input v-else v-model.lazy="inventory.available" class="sheet-input" @change="update(inventory)"/>
    </td>
  </tr>
</template>


<script>

  import sheet_repository from '@/repositories/sheet-repository'

  export default {
    props: {
      inventories: null,
    },

    methods: {
      async update(data) {
        try {
          this.$set(data, 'au', true);
          await sheet_repository.updateInventory(data);
        } catch (error) {
        } finally {
          this.$set(data, 'au', false);
        }
      }
    }

  }
</script>


<style scoped>
  @import "../sheet.css";
</style>